// Operator mode: an operator (admin portal user) works inside a client's
// case with a session for that client's workspace. Their own session is
// kept aside so "All cases" brings them straight back.

import type { Session } from "./auth";
import { wipeFlowState } from "./flowState";

const OPERATOR_SESSION_KEY = "vg-operator-session";

export function readOperatorSession(): Session | null {
  try {
    const raw = localStorage.getItem(OPERATOR_SESSION_KEY);
    return raw ? (JSON.parse(raw) as Session) : null;
  } catch {
    return null;
  }
}

export function stashOperatorSession(s: Session): void {
  try {
    localStorage.setItem(OPERATOR_SESSION_KEY, JSON.stringify(s));
  } catch {
    /* private mode */
  }
}

export function clearOperatorSession(): void {
  try {
    localStorage.removeItem(OPERATOR_SESSION_KEY);
  } catch {
    /* private mode */
  }
}

/** True while an operator is working inside a client's case. */
export function isOperatorInCase(current: Session | null): boolean {
  const op = readOperatorSession();
  return !!op && !!current && op.tenantId !== current.tenantId;
}

/** Everything one case leaves in the browser goes before another opens,
 *  so no stage, verdict or wizard answer carries over between clients. */
export function clearCaseState(): void {
  wipeFlowState();
  try {
    ["vg-paid", "vg-product", "h1b-case"].forEach((k) => localStorage.removeItem(k));
    ["sp-cv-b64", "sp-cv-mime", "sp-cv-name"].forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* private mode */
  }
}
